import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {MUTATION_KEYS, queryClient, QUERY_KEYS} from '@/queryClient'
import {httpDeleteActivityReport} from '@/features/accesses/activity-report/http/activityReport.http'
import {ActivityReportError} from '@/features/accesses/activity-report/types'
import {invalidateActivityReportExportAvailability} from './invalidateActivityReportExportAvailability'

// The report id is bound at hook level so the mutation is invoked as `mutate()` (no args) — this is
// what the shared DeleteDialog expects.
export const useDeleteActivityReport = (
    id: string,
    options?: Omit<UseMutationOptions<null, AxiosError<ActivityReportError>, void>, 'mutationKey' | 'mutationFn'>
) =>
    useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.DELETE_ACTIVITY_REPORT, id],
        mutationFn: () => httpDeleteActivityReport({id}),
        onSettled: (...args) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACTIVITY_REPORTS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACTIVITY_REPORT_COUNTERS]})
            invalidateActivityReportExportAvailability(queryClient)
            options?.onSettled?.(...args)
        }
    })
